import Input from '../../components/input/Input'
import Typography from '../../components/typography/Typography'
import appLogo from '../../assets/logo/app-logo.svg'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../store/builders/auth/auth.builders'
import './login.scss'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useScreenSize from '../../hooks/useScreenSize'
import Button from '../../components/button/Button'
import validateField from '../../utility/validation'
import { WelcomeText } from './Login'
import {
  setUserEmail,
  setUserOtp,
  setUserPhone,
} from '../../store/slice/auth/authenticationSlice'
import { UI_CONSTANT } from '../../utility/constants'
import useThrottle from '../../hooks/useThrottle'

function LoginWithPassword() {
  const screenSize = useScreenSize()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.auth) || {}
  const [isFormValid, setIsFormValid] = useState(false)
  const [blur, setBlur] = useState(false)
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    setIsFormValid(formData.email.trim() !== '' && formData.password.trim() !== '' && !errors.email && !errors.password)
  }, [formData.email, formData.password, errors])

  useEffect(() => {
    const handleEnterPress = (e) => {
      if ((e.key === 'Enter' || e.keyCode === 13) && isFormValid && !Object.values(errors).some((error) => error)) {
        handleThrottleLogin()
      }
    }

    document.addEventListener('keydown', handleEnterPress)

    return () => {
      document.removeEventListener('keydown', handleEnterPress)
    }
  }, [isFormValid, errors])

  const handleChange = (e) => {
    const { name, value } = e.target
    setBlur(false)
    // Validate the field value
    const error = validateField(name, value)
    // Update the form data and errors state
    setFormData({
      ...formData,
      [name]: value,
    })
    setErrors({
      ...errors,
      [name]: error,
    })
  }

  const handleBlur = (e) => {
    setBlur(true)
    const { name, value } = e.target
    const error = validateField(name, value)
    setErrors({
      ...errors,
      [name]: error,
    })
  }
  const handleLogin = async () => {
    const userEmail = formData.email.trim()
    const userPassword = formData.password
    dispatch(login({ userEmail, userPassword, navigate}))
  }
  const handleThrottleLogin = useThrottle(handleLogin, 2000)

  const handleEnterClick = (e) => {
    if ((e.key === 'Enter' || e.keyCode === 13) && isFormValid && !Object.values(errors).some((error) => error)) {
      handleThrottleLogin()
    }
  }
  return (
    <div className='wrapper'>
      <div className='container flex justify-center align-center'>
        <div className='section logo-section flex justify-center align-center'>
          <div className='container'>
            <img src={appLogo} alt='App Logo' />
          </div>
        </div>
        <div className='section login-section flex justify-center align-center'>
          <div className={`container ${screenSize} flex flex-column justify-evenly`}>
          <Typography onClick={()=> navigate('/contact-us')} textColor='red' textType='forgot' textWeight='400' style={{cursor: 'pointer', justifyContent: 'end', position: 'absolute', bottom: '20px', right: '20px'}}>
          Contact us
          </Typography>
            <WelcomeText title={UI_CONSTANT.LOGIN.WELCOME_TITLE} message={UI_CONSTANT.LOGIN.WELCOME_MESSAGE} />
            <div className='input-wrapper flex flex-column justify-center align-center'>
              <EmailPassInput
                errors={errors}
                handleChange={handleChange}
                formData={formData}
                handleBlur={handleBlur}
                blur={blur}
                handleLogin={handleLogin}
                handleEnterClick={handleEnterClick}
                loading={loading}
              />
            </div>
            <ButtonGroup
              handleLogin={handleLogin}
              loading={loading}
              isFormValid={isFormValid}
              errors={errors}
              path={'/login'}
              buttonName={UI_CONSTANT.LOGIN.LOGIN_WITH_OTP}
              blur={blur}
              onKeyDown={handleEnterClick}
              handleThrottleLogin={handleThrottleLogin}
            />
            <Typography onClick={()=> navigate('/privacy-policy')} textColor='red' textType='forgot' textWeight='400' style={{cursor: 'pointer', justifyContent: 'end', position: 'absolute', bottom: '20px', right: '120px'}}>
          Privacy Policy
          </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginWithPassword

export function EmailPassInput({ errors, handleChange,loading, formData, handleBlur, blur, handleEnterClick }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handlePassword = () => {
    dispatch(setUserEmail(null))
    navigate('/forgot-password')
  }

  // const handleEnterClick=(e)=>{
  //   if((e.key==='Enter' || e.keyCode===13) && errors){
  //     handleLogin()
  //   }
  // }

  return (
    <>
      <Input
        placeholder='Enter your Email'
        icon='email'
        name='email'
        value={formData.email}
        onChange={handleChange}
        error={errors.email}
        onBlur={(e) => handleBlur(e)}
        blur={blur}
        onKeyDown={handleEnterClick}
      />

      <div className='pass-forgot flex flex-column justify-end'>
        <Input
          placeholder='Enter your Password'
          icon='password'
          type='password'
          name='password'
          value={formData.password}
          onChange={handleChange}
          error={errors.password}
          onBlur={(e) => handleBlur(e)}
          blur={blur}
          onKeyDown={handleEnterClick}
        />
        <Button variant='normal' onClick={handlePassword} disabledBgColor={'otp-login'} disabled={loading} >
          <Typography textColor='red' textType='forgot' textWeight='400' >
            {UI_CONSTANT.LOGIN.FORGOT_PASSWORD}
          </Typography>
        </Button>
      </div>
    </>
  )
}

export function ButtonGroup({ handleThrottleLogin, loading, isFormValid, errors, path ,onKeyDown}) {
  const hasErrors = Object.values(errors).some((error) => error)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleNavigate = (routh) => {
    dispatch(setUserPhone(null))
    dispatch(setUserOtp(null))
    navigate(routh)
  }
  

  
  return (
    <div className='button-wrapper flex flex-column justify-center align-center'>
      <>
        <Button type='button' onClick={handleThrottleLogin} handleOnKeyDown={onKeyDown} customClassName={'otp-login'} disabledBgColor={'#ee4e56'}
 disabled={!isFormValid || loading || hasErrors}>
          <Typography textColor='white' textType='login-button' textWeight='700'>
            {loading ? UI_CONSTANT.LOADING : UI_CONSTANT.LOGIN.LOGIN}
          </Typography>
        </Button>
        <Typography textType='login-button' textColor='red' textWeight='600'>
          {UI_CONSTANT.OR}
        </Typography>
        <Button
          onClick={() => {
            handleNavigate(path)
          }}
          variant='outlined'
          disabledBgColor={'otp-login'}
          disabled={loading}
        >
          <Typography textColor='red' textType='login-button' textWeight='700'>
            {UI_CONSTANT.LOGIN.LOGIN_WITH_OTP}
          </Typography>
        </Button>
      </>
    </div>
  )
}
